import {
    TableBody as ReactAriaTableBody,
    TableBodyProps,
} from 'react-aria-components'

import { joinStyles } from 'app/utils/theme'

import * as styles from './index.css'

type TableBodyProperties = TableBodyProps<object> & {
    className?: string
}

export const TableBody = ({
    className,
    ...properties
}: Readonly<TableBodyProperties>): JSX.Element => {
    return (
        <ReactAriaTableBody
            className={joinStyles(styles.root, className)}
            {...properties}
        />
    )
}
